<template>
  <div class="recalc-modal">
    <div class="recalc-modal-head">
      <span>{{ 'RECALCULATE_TITLE' | translate }}</span>
    </div>
    <div class="recalc-message">
      <slot>
        {{ 'RECALCULATE_MESSAGE' | translate }}
      </slot>
    </div>
    <div class="recalc-actions">
      <button class="btn btn-primary" @click="$emit('yes')">{{ 'RECALCULATE' | translate }}</button>
      <button class="btn btn-secondary" @click="$emit('no')">{{ 'CANCEL' | translate }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyCaseRecalculate'
}
</script>

<style scoped>
.recalc-modal {
  text-align: center;
  padding: 24px;
}
.recalc-modal-head {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 18px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.recalc-message {
  margin-bottom: 24px;
}
.recalc-actions button + button {
  margin-left: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/case/PolicyCaseRecalculate.vue